import $foreign from "./foreign.cjs";
var _addClass = $foreign._addClass;
var _initClasses = $foreign._initClasses;
var _stopPropagation = $foreign._stopPropagation;
export { _addClass, _initClasses, _stopPropagation };
